const resetSelection = (prevState, { treeId, selection, plugins, adapter }) => {
  const treeState = prevState[treeId];
  if (!treeState) {
    return;
  }

  const { selection: selectionPlugin } = plugins;
  if (!selectionPlugin) {
    return prevState;
  }

  const nextTreeState = { ...treeState };

  selectionPlugin.setSelection(nextTreeState, selection, { adapter });

  return {
    ...prevState,
    [treeId]: nextTreeState,
  };
};
export default resetSelection;
